module.exports = __webpack_public_path__ + "static/media/remove-workspace-icon.59d54af3.svg";